/**
 * @generated SignedSource<<b0ffaa0ebb2034f1924f8c532dfcb4a5>>
 * @relayHash dbd963bf62e2192ae511b690637581cf
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dbd963bf62e2192ae511b690637581cf

import { ConcreteRequest } from 'relay-runtime';
export type useLazyLoadedRolesQuery$variables = Record<PropertyKey, never>;
export type useLazyLoadedRolesQuery$data = {
  readonly suggestedRoles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "Role";
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
};
export type useLazyLoadedRolesQuery = {
  response: useLazyLoadedRolesQuery$data;
  variables: useLazyLoadedRolesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SuggestedRoleConnection",
    "kind": "LinkedField",
    "name": "suggestedRoles",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SuggestedRoleEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Role",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useLazyLoadedRolesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useLazyLoadedRolesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "dbd963bf62e2192ae511b690637581cf",
    "metadata": {},
    "name": "useLazyLoadedRolesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bca8c09d8b572d10bd247e90541ecefc";

export default node;
